<template>
  <section class="block-with-small-image">
    <div class="container">
      <div
        v-for="(block, index) in data"
        :key="index"
        :class="`block-with-small-image__wrapp_${block.imgPosition}`"
        class="block-with-small-image__wrapp"
      >
        <TitleWithLines
          v-if="block.title"
          :title="block.title"
        />

        <div 
          class="block-with-small-image__body"
        >
          <div
            v-if="block.description"
            ref="description"
            class="block-with-small-image__description custom-editor"
            v-html="block.description"
          />

          <div class="block-with-small-image__img">
            <img
              v-if="block.imageUrl"
              :src="`${setImageUrl()}${block.imageUrl}`"
              alt="image"
            >
            <div
              v-if="block.imageSvg"
              class="block-with-small-image__img-icon"
              v-html="block.imageSvg"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import TitleWithLines from '@/components/shared/TitleWithLines'
  export default {
    name: 'AdvantageBlocks',

    components: { TitleWithLines },

    props: {
      data: {
        type: Array,
        default: () => []
      }
    },

    mounted () {
      this.setImageUrl()
      this.toggleHint()
    },

    methods: {
      setImageUrl () {
        return process.env.VUE_APP_API
      },
      toggleHint () {
        if (!this.$store.getters.isMobile) return
        const descriptions = this.$refs.description
        const links = Array.from(descriptions)

        for (let i = 0; i < links.length; i++) {
          const link = links[i]
          const text = links[i].querySelector('u')

          if (link) {
            link.addEventListener('click', (evt) => {
              if (evt.target === text) {
                text.classList.add('show')
              } else {
                text.classList.remove('show')
              }
            })
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.block-with-small-image {
  position: relative;
  overflow: hidden;

  .title-with-lines {
    width: 100%;
    max-width: 1015px;

    @include mobile {
      margin-bottom: 48px;
      padding-left: 16px;
      padding-right: 50px;
    }
  }

  &__wrapp {
    padding-top: 192px;

    @include tablet {
      padding-top: 96px;
    }

    &_right {
      .custom-editor u::before {
        right: 0;
        left: 0;
      }
    }

    &_left {
      .title-with-lines,
      .title-with-lines__title {
        margin-left: auto;
      }

      .title-with-lines {
        padding-right: 114px;

        @include mobile {
          padding-right: 16px;
          padding-left: 90px;
        }
      }

      .block-with-small-image__body {
        flex-direction: row-reverse;
        align-items: center;

        @include mobile {
          width: calc(100% + 16px);
          margin-right: 0;
          margin-left: -16px;
        }
      }

      .block-with-small-image__description {
        padding-top: 0;
      }

      .block-with-small-image__img-icon {
        left: auto;
        right: 0;
        transform: translate(50%, 50%);
      }
    }

    &_center {
      .title-with-lines__title {
        margin-left: auto;
      }

      .title-with-lines {
        margin-left: 210px;
        margin-bottom: -90px;

        @include tablet {
          margin-left: 0;
        }

        @include mobile {
          margin-bottom: 24px;
          padding-right: 16px;
          padding-left: 100px;
        }
      }

      .title-with-lines__lines {
        transform: translateY(-50%) translateY(-30px);

        @include mobile {
         transform: translateY(-50%) translateY(-28px);
        }
      }

      .block-with-small-image__body {
        max-width: 900px;
        margin: 0 auto;

        @include mobile {
          width: calc(100% + 32px);
          margin-left: -16px;
        }
      }

      .block-with-small-image__img {
        max-width: 900px;

        @include aspect-ratio(900/416);

        &::after {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: radial-gradient(99.94% 242.62% at 91.49% 16.12%, rgba(255, 255, 255, 0.56) 0%, rgba(255, 255, 255, 0) 100%);
          content: '';
          z-index: 0;
        }
      }

      .title-with-lines__title span {
        color: $c-red;
      }
    }

    &:nth-child(3) {
      .title-with-lines__title,
      p {
        max-width: 630px;
      }
    }
  }

  &__body {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 792px;
    margin-left: auto;
    margin-right: 230px;

    @include mobile {
      margin-right: -16px;
    }
  }

  &__description {
    width: 100%;
    max-width: 325px;
    padding-top: 160px;
    font-size: 24px;
    line-height: 1.34;
    color: $c-black;

    @include mobile {
      font-size: 14px;
      line-height: 18px;
      max-width: 120px;
      padding-top: 30px;
    }
  }

  &__img {
    width: 100%;
    max-width: 325px;

    @include mobile {
      max-width: 162px;
    }

    &-icon {
      position: absolute;
      bottom: 0;
      left: 0;
      transform: translate(-50%, 50%);

      @include mobile {
        width: 100px;

        svg {
          width: 100%;
        }
      }
    }

    @include aspect-ratio(325/464);

    @include mobile {
      @include aspect-ratio(162/216);
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      @include object-fit-cover();
    }
  }
}
</style>
